import React, { useState, useRef, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import DashSideBar from "../../shared/DashSideBar";
import "./FAQs.css";
import { Editor } from "primereact/editor";
import { Dropdown } from "primereact/dropdown";

function FAQs() {
  let emptyFAQ = {
    id: null,
    question: "",
    answer: null,
    sortOrder: null,
  };
  const [FAQs, setFAQs] = useState(null);

  const [FAQsDialog, setFAQsDialog] = useState(false);
  const [DeleteFAQ, setDeleteFAQ] = useState(false);
  const [DeleteFAQsDialog, setDeleteFAQsDialog] = useState(false);
  const [FAQ, setFAQ] = useState(emptyFAQ);
  const [selectedFAQs, setSelectedFAQs] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const dt = useRef(null);

  const isFetched = useRef(false);

  useEffect(() => {
    if (!isFetched.current) {
      getFAQs();
      isFetched.current = true; // Ensure it only runs once
    }
  }, []);

  const getFAQs = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/FAQs"
      );

      if (response.data) {
        setFAQs(response.data);
      }
    } catch (error) {
      console.error("Error fetching FAQs:", error);
    }
  };

  const openNew = () => {
    setFAQ(emptyFAQ);
    setSubmitted(false);
    setFAQsDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setFAQsDialog(false);
  };

  const hideDeleteProductDialog = () => {
    setDeleteFAQ(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeleteFAQsDialog(false);
  };

  const saveFAQ = async () => {
    setLoading(true);
    setSubmitted(true);

    try {
      let _FAQs = [...FAQs];
      let _FAQ = { ...FAQ };

      if (FAQ.id) {
        const index = findIndexById(FAQ.id);

        const payload = {
          Id: FAQ.id,
          Question: _FAQ.question,
          SortOrder: isNaN(parseInt(_FAQ.sortOrder))
            ? 1
            : parseInt(_FAQ.sortOrder),
          Answer: _FAQ.answer,
        };

        const response = await axios.put(
          process.env.REACT_APP_BACKEND_URL + "api/FAQs/" + FAQ.id,
          payload,
          {
            headers: {
              "Content-Type": "application/json", // ✅ Proper for JSON body
            },
          }
        );

        if (response.data) {
          _FAQs[index] = _FAQ;
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Our FAQ Updated",
            life: 3000,
          });
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Our FAQ Not Updated",
            life: 3000,
          });
        }
      } else {
        _FAQ.id = createId();
        const payload = {
          Question: _FAQ.question,
          SortOrder: isNaN(parseInt(_FAQ.sortOrder))
            ? 1
            : parseInt(_FAQ.sortOrder),
          Answer: _FAQ.answer,
        };

        const response = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "api/FAQs",
          payload,
          {
            headers: {
              "Content-Type": "application/json", // ✅ Proper for JSON body
            },
          }
        );

        if (response.data) {
          _FAQs.push(response.data);
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Our FAQ Added",
            life: 3000,
          });
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Our FAQ Not Added",
            life: 3000,
          });
        }
      }

      setFAQs(_FAQs);
      setFAQsDialog(false);
      setFAQ(emptyFAQ);
    } catch (error) {
      console.error("Error during save operation:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail:
          "An error occurred while saving the list content. Please try again later.",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const editProduct = (FAQ) => {
    setFAQ({ ...FAQ });
    setFAQsDialog(true);
  };

  const confirmDeleteProduct = (FAQ) => {
    setFAQ(FAQ);
    setDeleteFAQ(true);
  };

  const deleteProduct = async () => {
    setLoading(true);
    try {
      const response = await axios.delete(
        process.env.REACT_APP_BACKEND_URL + "api/FAQs/" + FAQ.id
      );

      setLoading(false);

      if (response.data.success) {
        let _FAQs = FAQs.filter((val) => val.id !== FAQ.id);
        setFAQs(_FAQs);
        setDeleteFAQ(false);
        setFAQ(emptyFAQ);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Our FAQ Deleted",
          life: 3000,
        });
      } else {
        throw new Error("Unexpected response");
      }
    } catch (error) {
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Our FAQ Not Deleted",
        life: 3000,
      });
    }
  };

  const findIndexById = (id) => {
    let index = -1;

    for (let i = 0; i < FAQs.length; i++) {
      if (FAQs[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeleteFAQsDialog(true);
  };

  const deleteSelectedProducts = async () => {
    setLoading(true);
    const ids = selectedFAQs.map((FAQ) => FAQ.id);
    const idsString = ids.join(",");
    let data = { Ids: idsString };
    const response = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "api/FAQs/DeleteByIds",
      data
    );
    setLoading(false);
    if (response.data.success) {
      let _FAQs = FAQs.filter((val) => !selectedFAQs.includes(val));
      setFAQs(_FAQs);
      setDeleteFAQsDialog(false);
      setSelectedFAQs(null);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Our FAQs Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Our FAQs Not Deleted",
        life: 3000,
      });
    }
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _FAQ = { ...FAQ };

    _FAQ[`${name}`] = val;

    setFAQ(_FAQ);
  };
  const leftToolbarTemplate = () => {
    return (
      <div className="d-flex align-items-center justify-content-center gap-5">
        <h4 className="m-0 title-of-table">Manage FAQ</h4>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            style={{ border: "1px solid black" }}
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search..."
          />
        </span>
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <div className="d-flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          onClick={confirmDeleteSelected}
          disabled={!selectedFAQs || !selectedFAQs.length}
        />
      </div>
    );
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          style={{ marginRight: "10px" }}
          onClick={() => editProduct(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteProduct(rowData)}
        />
      </React.Fragment>
    );
  };
  const header = (
    <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
      {/* <h4 className="m-0">Manage Product Icons</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span> */}
    </div>
  );
  const productDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        style={{ borderRadius: "10px" }}
        onClick={hideDialog}
      />
      <Button
        label="Save"
        loading={loading}
        style={{ borderRadius: "10px" }}
        icon="pi pi-check"
        onClick={saveFAQ}
      />
    </React.Fragment>
  );
  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteProduct}
      />
    </React.Fragment>
  );
  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );
  function truncateHtml(html, maxLength) {
    const div = document.createElement("div");
    div.innerHTML = html;
    const text = div.textContent || div.innerText || "";
    const truncatedText =
      text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
    return truncatedText;
  }

  return (
    <div className="col-12 d-flex">
      <div className="col-3">
        <DashSideBar />
      </div>
      <div className="col-9">
        <div className="FAQ-container">
          <Toast ref={toast} />
          <div className="card">
            <Toolbar
              className="mb-3"
              start={leftToolbarTemplate}
              end={rightToolbarTemplate}
            ></Toolbar>

            <DataTable
              ref={dt}
              value={FAQs}
              selection={selectedFAQs}
              onSelectionChange={(e) => setSelectedFAQs(e.value)}
              dataKey="id"
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Product Icons"
              globalFilter={globalFilter}
              header={header}
            >
              <Column selectionMode="multiple" exportable={false}></Column>
              <Column
                field="id"
                header="Code"
                sortable
                width="150px"
                style={{ textAlign: "center" }}
              ></Column>

              <Column
                field="question"
                header="Question"
                sortable
                style={{ minWidth: "12rem" }}
              ></Column>
              <Column
                field="sortOrder"
                header="Order"
                sortable
                style={{ textAlign: "center" }}
              ></Column>

              <Column
                body={actionBodyTemplate}
                exportable={false}
                style={{ minWidth: "12rem" }}
              ></Column>
            </DataTable>
          </div>

          <Dialog
            visible={FAQsDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="FAQ Details"
            modal
            className="p-fluid"
            footer={productDialogFooter}
            onHide={hideDialog}
          >
            <div className="field">
              <label htmlFor="question" className="font-bold mb-1">
                Question :
              </label>
              <InputText
                id="question"
                value={FAQ.question ?? ""}
                onChange={(e) => onInputChange(e, "question")}
                required
                className={classNames({
                  "p-invalid": submitted && !FAQ.question,
                })}
              />
              {submitted && !FAQ.question && (
                <small className="p-error">Question is required.</small>
              )}
            </div>
            <div className="field">
              <label htmlFor="answer" className="font-bold mb-1">
                Answer :
              </label>
              <Editor
                id="answer"
                value={FAQ.answer ?? ""}
                style={{ height: "100px" }}
                onTextChange={(e) =>
                  onInputChange({ target: { value: e.htmlValue } }, "answer")
                }
                required
                className={classNames({
                  "p-invalid": submitted && !FAQ.answer,
                })}
              />
            </div>
            <div className="field">
              <label htmlFor="sortOrder" className="font-bold mt-3 mb-1">
                Order :
              </label>
              <InputText
                id="sortOrder"
                type="number"
                value={FAQ.sortOrder ?? 1}
                onChange={(e) => onInputChange(e, "sortOrder")}
                required
                className={classNames({
                  "p-invalid": submitted && !FAQ.sortOrder,
                })}
              />
              {submitted && !FAQ.sortOrder && (
                <small className="p-error">Sort Order is required.</small>
              )}
            </div>
          </Dialog>

          <Dialog
            visible={DeleteFAQ}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductDialogFooter}
            onHide={hideDeleteProductDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              <div>
                <p style={{ textAlign: "center", marginBottom: "5px" }}>
                  Are you sure you want to delete:
                </p>
                {FAQ && (
                  <p style={{ textAlign: "center", marginBottom: "0" }}>
                    <b>{FAQ.title}</b>
                  </p>
                )}
              </div>
            </div>
          </Dialog>

          <Dialog
            visible={DeleteFAQsDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductsDialogFooter}
            onHide={hideDeleteProductsDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              {FAQ && (
                <p
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "25px",
                  }}
                >
                  Are you sure you want to delete the selected FAQs?
                </p>
              )}
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  );
}

export default FAQs;
